var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemiHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 606.59 325.6",
    style: {
      enableBackground: "new 0 0 606.59 325.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M303.43,240.89c-1.97,0-4.02-0.35-6.08-1.04l-0.2-0.07L154.8,186.22v54.66c0,25.31,26.16,40.97,48.1,49.66 c27.47,10.87,64.06,17.11,100.4,17.11s72.93-6.24,100.4-17.11c21.94-8.69,48.1-24.35,48.1-49.66v-54.57l-142.1,53.42 C307.64,240.5,305.53,240.89,303.43,240.89z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.16,211.38 81.27,211.55 81.27,158.55 62.16,151.36  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.62,325.6l-0.06,0c-2.31-0.09-3.87-1.95-4.81-3.05l-46.64-55.08c-0.52-0.55-1.16-1.39-1.12-2.57 c0.04-1.44,1.29-2.56,2.84-2.56c2.2,0,4.19,0.01,6.16,0.01c1.93,0.01,3.85,0.01,5.94,0.01h0.66l37.03,43.87l37.03-43.87 l12.92-0.01c1.53,0,2.64,1.05,2.68,2.54c0.04,1.18-0.61,2.03-1.17,2.63l-46.6,55.03c-0.93,1.11-2.49,2.96-4.81,3.05L70.62,325.6z  M107.33,253.75l-17.24-17.84H51.15l-17.24,17.84h-0.6c0,0-11.45-0.01-12.56,0c0,0,0,0-0.01,0c-1.51,0-2.71-1.09-2.75-2.47 c-0.04-1.41,0.89-2.35,1.51-2.98l0.18-0.18l25.23-26.11h51.44l25.41,26.29c0.61,0.62,1.54,1.56,1.5,2.97 c-0.04,1.41-1.19,2.47-2.68,2.47L107.33,253.75z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M600.08,99.6L306.91,0.66c-2.35-0.88-4.87-0.88-7.15-0.02L6.48,99.62C2.63,101.06,0,104.86,0,109.04 c0,4.18,2.63,7.98,6.55,9.45l33.52,12.6l0.05-0.14l22.1,8.32c0.1-7.07,9.55-10.26,9.55-10.26l134.16-45.08 c6.72-2.07,11.3-4.34,18.11-1.84c3.3,1.21,9.42,5.92-0.81,9.11L92.28,135c0,0-11.09,2.86-11.15,11.38l219.9,82.74 c1.76,0.57,3.15,0.56,4.7-0.02l294.31-110.61c3.92-1.47,6.55-5.27,6.55-9.45C606.59,104.87,603.98,101.08,600.08,99.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiHat);
export default __webpack_public_path__ + "static/media/semiHat.936246664a105c8646c3fe0236394aa5.svg";
export { ForwardRef as ReactComponent };